import React from 'react';
import {Route, Switch} from 'react-router-dom';

import NetworksList from 'routes/app/components/Configuration/NetworkList';
import NetworkForm from 'routes/app/components/Configuration/NetworkForm';

class Facebook extends React.Component {

  render() {
    return (
      <Switch>
        <Route path={`${this.props.match.path}/edit/:id`}
               render={( props ) => <NetworkForm type="facebook" {...props}/>}/>
        <Route path={`${this.props.match.path}/new`} render={( props ) => <NetworkForm type="facebook" {...props}/>}/>
        <Route path={`${this.props.match.path}`} render={() => <NetworksList type="facebook"/>}/>
      </Switch>
    )
  }
}

module.exports = Facebook;



// WEBPACK FOOTER //
// ./routes/app/routes/configuration/facebook/index.js